/**
 * HeritageWood - Product Page JavaScript
 * Handles all interactivity for the premium product page
 */

(function() {
  'use strict';

  let hwZoomIndex = 0;
  let hwGalleryImages = null;

  function hwGetGalleryImages() {
    if (hwGalleryImages) return hwGalleryImages;

    const dataEl = document.getElementById('hwProductGalleryData');
    if (dataEl) {
      try {
        const parsed = JSON.parse(dataEl.textContent);
        if (Array.isArray(parsed) && parsed.length) {
          hwGalleryImages = parsed;
          return hwGalleryImages;
        }
      } catch (err) {
        console.warn('Could not parse product gallery data', err);
      }
    }

    hwGalleryImages = [];
    return hwGalleryImages;
  }

  function hwSrcsetFromUrl(url) {
    if (!url) return '';
    const withWidth = (width) => (
      /width=\d+/.test(url) ? url.replace(/width=\d+/, 'width=' + width) : url
    );
    return withWidth(400) + ' 400w, ' + withWidth(800) + ' 800w, ' + withWidth(1200) + ' 1200w';
  }

  function hwGetMainFrame() {
    return document.getElementById('hwMainImage');
  }

  function hwSetZoomBackground(src) {
    const frame = hwGetMainFrame();
    if (!frame || !src) return;
    frame.style.backgroundImage = 'url("' + src + '")';
  }

  function hwSetZoomed(zoomed) {
    const frame = hwGetMainFrame();
    const trigger = document.getElementById('hwZoomTrigger');
    const status = document.getElementById('hwZoomStatus');
    if (!frame) return;

    frame.classList.toggle('is-zoomed', zoomed);
    if (!zoomed) {
      frame.style.backgroundPosition = '50% 50%';
    }

    if (trigger) {
      trigger.setAttribute('aria-label', zoomed ? 'Micșorează imaginea' : 'Mărește imaginea');
    }
    if (status) {
      status.textContent = zoomed ? 'Imagine mărită' : 'Imagine normală';
    }
  }

  function hwPanZoom(clientX, clientY) {
    const frame = hwGetMainFrame();
    if (!frame || !frame.classList.contains('is-zoomed')) return;

    const rect = frame.getBoundingClientRect();
    if (!rect.width || !rect.height) return;

    const x = Math.min(100, Math.max(0, ((clientX - rect.left) / rect.width) * 100));
    const y = Math.min(100, Math.max(0, ((clientY - rect.top) / rect.height) * 100));
    frame.style.backgroundPosition = x + '% ' + y + '%';
  }

  window.hwSwitchImage = function(index) {
    const images = hwGetGalleryImages();
    const item = images[index];
    const mainImage = document.querySelector('.hw-product-main-image img');
    const thumbnails = document.querySelectorAll('.hw-product-thumbnail');
    const trigger = document.getElementById('hwZoomTrigger');

    if (!mainImage || !item) return;

    hwZoomIndex = index;
    mainImage.src = item.display || item.src;
    mainImage.srcset = hwSrcsetFromUrl(item.display || item.src);
    mainImage.alt = item.alt || '';
    mainImage.setAttribute('data-zoom-src', item.src);
    hwSetZoomBackground(item.src);
    hwSetZoomed(false);

    if (trigger) trigger.setAttribute('data-zoom-index', String(index));

    thumbnails.forEach((thumb, i) => {
      thumb.classList.toggle('active', i === index);
    });
  };

  // Quantity Selector
  window.hwChangeQty = function(delta) {
    const input = document.querySelector('.hw-qty-input');
    if (!input) return;
    
    const currentValue = parseInt(input.value) || 1;
    const newValue = Math.max(1, currentValue + delta);
    input.value = newValue;
  };

  // Personalization Toggle
  window.hwTogglePersonalization = function() {
    const toggle = document.getElementById('hwEngravingToggle');
    const checkbox = document.getElementById('hwPersonalizationCheckbox');
    const form = document.getElementById('hwPersonalizationForm');
    const input = document.getElementById('hwGravuraText');

    if (toggle) {
      toggle.checked = !toggle.checked;
      toggle.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    if (!checkbox || !form) return;

    const isActive = form.classList.contains('active');
    form.classList.toggle('active', !isActive);
    checkbox.classList.toggle('checked', !isActive);
    if (input) input.disabled = isActive;
  };

  // Character Count for Engraving
  window.hwUpdateCharCount = function(input) {
    const count = document.getElementById('hwCharCount');
    if (!count) return;
    
    count.textContent = input.value.length + ' / 100';
  };

  // Set Example Text
  window.hwSetText = function(text) {
    const input = document.getElementById('hwGravuraText');
    if (!input) return;
    
    input.value = text;
    hwUpdateCharCount(input);
  };

  // Accordion Toggle
  window.hwToggleAccordion = function(button) {
    const item = button.closest('.hw-accordion-item');
    if (!item) return;
    
    const isOpen = item.classList.contains('open');
    
    // Close all accordion items
    document.querySelectorAll('.hw-accordion-item').forEach(i => {
      i.classList.remove('open');
    });
    
    // Open clicked item if it wasn't open
    if (!isOpen) {
      item.classList.add('open');
    }
  };

  // Buy Now - Redirect to checkout
  window.hwBuyNow = function() {
    const form = document.getElementById('hw-product-form');
    if (!form) return;
    
    // Add ?checkout query parameter to form action
    const formData = new FormData(form);
    const variantId = formData.get('id');
    const quantity = formData.get('quantity') || 1;
    
    // Build checkout URL
    window.location.href = `/cart/${variantId}:${quantity}?checkout=true`;
  };

  // Quick Add to Cart (for recommended products)
  window.hwQuickAddToCart = function(button) {
    if (!button) {
      console.error('No button provided to hwQuickAddToCart');
      return false;
    }
    
    const variantId = button.dataset.variantId || button.getAttribute('data-variant-id');
    
    if (!variantId) {
      console.error('No variant ID found on button:', button);
      alert('Eroare: Nu s-a găsit ID-ul variantei produsului.');
      return false;
    }
    
    // Disable button
    button.disabled = true;
    const originalText = button.innerHTML;
    button.innerHTML = '<span style="opacity: 0.7;">Se adaugă...</span>';
    
    // Build form data
    const formData = {
      id: variantId.toString(),
      quantity: 1
    };
    
    console.log('hwQuickAddToCart called with:', formData);
    
    // Add to cart via AJAX
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      console.log('Cart API response status:', response.status);
      if (!response.ok) {
        return response.json().then(err => {
          throw new Error(err.description || err.message || 'Failed to add to cart');
        });
      }
      return response.json();
    })
    .then(data => {
      console.log('Successfully added to cart:', data);
      button.innerHTML = '<span style="color: #2d7a3e; font-weight: 600;">✓ Adăugat în coș!</span>';
      
      // IMMEDIATE cart count update
      updateCartCount();
      
      // Also try to manually increment visible count (fallback)
      const cartCounts = document.querySelectorAll('.cart-count-bubble, [data-cart-count], .cart-count, #cart-icon-bubble');
      cartCounts.forEach(el => {
        if (el && el.textContent) {
          const currentCount = parseInt(el.textContent) || 0;
          el.textContent = currentCount + 1;
          el.style.display = '';
          el.removeAttribute('hidden');
        }
      });
      
      // Trigger all possible cart events
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      
      // Try to open cart drawer
      setTimeout(() => {
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          if (typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          } else if (typeof cartDrawer.openDrawer === 'function') {
            cartDrawer.openDrawer();
          } else {
            cartDrawer.classList.add('active', 'is-open');
            cartDrawer.setAttribute('open', '');
          }
        }
        
        // Also try mini-cart
        const miniCart = document.querySelector('#mini-cart, .mini-cart, [id*="mini-cart"]');
        if (miniCart) {
          miniCart.classList.add('active', 'is-open');
        }
      }, 100);
      
      // Reset button after 3 seconds
      setTimeout(() => {
        button.innerHTML = originalText;
        button.disabled = false;
      }, 3000);
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
      button.innerHTML = '<span style="color: #c94c4c;">Eroare</span>';
      alert('Nu s-a putut adăuga produsul în coș. Eroare: ' + error.message);
      setTimeout(() => {
        button.innerHTML = originalText;
        button.disabled = false;
      }, 2000);
    });
    
    return false;
  };

  // Get favorites from localStorage (using same system as hw-wishlist.js)
  function getFavorites() {
    try {
      const stored = JSON.parse(localStorage.getItem('hw_favorites') || '[]');
      return Array.isArray(stored) ? stored : [];
    } catch (err) {
      return [];
    }
  }

  // Save favorites to localStorage
  function saveFavorites(list) {
    localStorage.setItem('hw_favorites', JSON.stringify(list));
    // Trigger update event for other scripts
    document.dispatchEvent(new CustomEvent('hw:wishlist-updated', { detail: list }));
    
    // Update header count
    const count = list.length;
    document.querySelectorAll('[data-hw-wishlist-count]').forEach(el => {
      el.textContent = String(count);
      if (count > 0) {
        el.removeAttribute('hidden');
      } else {
        el.setAttribute('hidden', '');
      }
    });
  }

  // Toggle Wishlist (for recommended products) - connected to main wishlist system
  window.hwToggleWishlist = function(button) {
    const productHandle = button.dataset.productHandle;
    if (!productHandle) return;
    
    const favorites = getFavorites();
    const index = favorites.indexOf(productHandle);
    const isAdding = index === -1;
    
    if (isAdding) {
      favorites.push(productHandle);
      button.classList.add('active');
    } else {
      favorites.splice(index, 1);
      button.classList.remove('active');
    }
    
    saveFavorites(favorites);
  };

  // Update cart count in header - ALL POSSIBLE SELECTORS - GLOBAL FUNCTION
  window.updateCartCount = function() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        console.log('Cart updated, item count:', cart.item_count);
        
        // All possible cart count selectors
        const selectors = [
          '.cart-count-bubble',
          '[data-cart-count]',
          '.cart-count',
          '#cart-icon-bubble',
          '.cart-icon-bubble',
          '[id*="cart-count"]',
          '[class*="cart-count"]',
          'cart-count-bubble',
          '.header__icon--cart .badge',
          '.cart-link .badge',
          '.cart-icon .count'
        ];
        
        let updated = false;
        
        selectors.forEach(selector => {
          const elements = document.querySelectorAll(selector);
          elements.forEach(el => {
            if (el) {
              el.textContent = cart.item_count;
              el.style.display = cart.item_count > 0 ? '' : 'none';
              if (cart.item_count > 0) {
                el.removeAttribute('hidden');
              }
              updated = true;
              console.log('Updated element:', selector, 'with count:', cart.item_count);
            }
          });
        });
        
        if (!updated) {
          console.warn('No cart count elements found. Searched selectors:', selectors);
        }
        
        // Dispatch event for other scripts
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: { cart: cart, item_count: cart.item_count }
        }));
      })
      .catch(error => console.error('Error updating cart count:', error));
  };

  // Also expose as hwUpdateCartCount for easy access
  window.hwUpdateCartCount = window.updateCartCount;

  // Sync wishlist buttons on page load
  function syncWishlistButtons() {
    const favorites = getFavorites();
    document.querySelectorAll('.hw-rec-wishlist').forEach(button => {
      const handle = button.dataset.productHandle;
      if (handle && favorites.includes(handle)) {
        button.classList.add('active');
      }
    });
  }

  // Setup event listeners for recommended products
  function setupRecommendedProductListeners() {
    // Add to cart buttons - use event delegation
    document.addEventListener('click', function(e) {
      const addToCartBtn = e.target.closest('.hw-rec-add-to-cart');
      if (addToCartBtn && !addToCartBtn.disabled) {
        e.preventDefault();
        e.stopPropagation();
        console.log('Add to cart button clicked:', addToCartBtn);
        hwQuickAddToCart(addToCartBtn);
      }
    }, true);
    
    // Log all buttons on page load for debugging
    console.log('Found add to cart buttons:', document.querySelectorAll('.hw-rec-add-to-cart').length);
  }

  function setupProductZoom() {
    const frame = hwGetMainFrame();
    const trigger = document.getElementById('hwZoomTrigger');
    const mainImage = frame && frame.querySelector('img');
    if (!frame || !trigger || !mainImage) return;

    hwSetZoomBackground(mainImage.getAttribute('data-zoom-src') || mainImage.src);

    trigger.addEventListener('click', function() {
      hwSetZoomed(!frame.classList.contains('is-zoomed'));
    });

    trigger.addEventListener('mousemove', function(e) {
      hwPanZoom(e.clientX, e.clientY);
    });

    trigger.addEventListener('touchmove', function(e) {
      if (!frame.classList.contains('is-zoomed') || !e.touches[0]) return;
      hwPanZoom(e.touches[0].clientX, e.touches[0].clientY);
    }, { passive: true });
  }

  function initProductPage() {
    syncWishlistButtons();
    setupRecommendedProductListeners();
    setupProductZoom();
    document.addEventListener('hw:wishlist-updated', syncWishlistButtons);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductPage);
  } else {
    initProductPage();
  }

})();
